import {
    types
} from './types';
import firebase from '../firebase/firebase';

const db = firebase.database();


const acceptedImageTypes = ['profilePhotoURL', 'providerProfilePhoto', 'providerCoverPhoto', 'serviceCoverPhoto', 'companyLogo', 'adminProfilePhoto', 'coverPhotoURL'];
const acceptedPersonalValues = ['email', 'name', 'roles', 'phone'];

const _getImageURL = ({
    imageData,
    dbNodeId,
    imageType
}) => {
    return new Promise(function (resolve, reject) {
        //plug my own image types
        if (imageType && acceptedImageTypes.includes(imageType)) {
            if (imageData) {
                let fs_imageBasePath = `${imageType}s`;
                const fs_path = `${fs_imageBasePath}/${dbNodeId}/${imageData.name}`;
                const file = imageData;

                uploadFileToFs(fs_path, file, (downloadURL) => {
                    resolve(downloadURL);
                });
            } else {
                reject(new Error('No imageData option passed to _getImageURL function.'));
                return null;
            }
        } else if (!imageType) {
            reject(new Error('No imageType has been provided to _getImageURL function.'));
            return null;
        } else {
            reject(new Error('Please provide a valid imageType to _getImageURL function.'));
            return null;
        }
    });
}

const uploadFileToFs = (path, file, cb) => {
    const logoStorageRef = firebase.storage().ref(path);
    let uploadTask = logoStorageRef.put(file);

    uploadTask.on('state_changed', (snap) => {
        switch (snap.state) {
            case 'paused':
                console.log('Upload is paused.');
                break;
            case 'running':
                console.log('Upload task is running...');
                break;
            case 'complete':
                console.log('Upload complete.');
                break;

        }
    }, error => {
        switch (error.code) {
            case 'storage/unauthorized':
                console.log('Upload permission denied: You dont have permission to upload to this location...');
                break;
            case 'storage/canceled':
                console.log('Upload canceled by user.');
                break;
            case 'storage/unknown':
                console.log('Error: unknown error occurred. Upload failed.');
                break;
        }
    }, () => {
        const downloadURL = uploadTask.snapshot.ref.getDownloadURL();
        console.log('success', downloadURL);
        cb(downloadURL);
    });
}

export const getDBProviderCompanies = () => async dispatch => {

    const onGetProviderCompanies = (snap) => {
        let providerCompanies = [];

        snap.forEach(providerCompanySnap => {
            if (providerCompanySnap) {
                providerCompanies.push(providerCompanySnap.val());
            }
        });

        dispatch({
            type: types.GET_ALL_PROVIDER_COMPANIES,
            payload: providerCompanies
        });
    }

    db.ref(`/providerCompanies`).once('value', onGetProviderCompanies, (e) => console.log);
}

const getEmployeeTypeData = async (employeeTypePromises) => {
    let employeeTypeInfo = [];
    const employeeTypeData = await Promise.all(employeeTypePromises)
    .then( async snap => {
        for (const employee of snap) {
            let employeeData = employee.val();
            let basicProfileSnap = await db.ref(`clients/${employeeData.uid}/basicProfile`).once('value', dataSnapshot => dataSnapshot, e => console.log)
            const basicProfileData = basicProfileSnap.val();
            employeeData['phone'] = basicProfileData['phone'];
            employeeData['fullName'] = `${employeeData.name.first} ${employeeData.name.last}`
            employeeTypeInfo.push(employeeData);
        }
        return employeeTypeInfo;
    });
    return employeeTypeData;
};

export const getCompanyInfo = (id) => async dispatch => {
    return new Promise(async (resolve, reject) => {

        const onGetInfo = async (companySnap) => {
            const companyInfo = companySnap.val();
            const providerPromises = Object.keys(companyInfo.providers || []).map(providerId => {
                return db.ref(`/providers/${providerId}`).once('value', dataSnapshot => dataSnapshot, e => console.log);
            });
            const accountAdminPromises = Object.keys(companyInfo.accountAdmins || []).map(adminId => {
                return db.ref(`/accountAdmins/${adminId}`).once('value', dataSnapshot => dataSnapshot, e => console.log);
            });
            const staffAdminPromises = Object.keys(companyInfo.staffAdmins || []).map(adminId => {
                return db.ref(`/staffAdmins/${adminId}`).once('value', dataSnapshot => dataSnapshot, e => console.log);
            });

            const providersArray = await getEmployeeTypeData(providerPromises);
            const staffAdminsArray = await getEmployeeTypeData(staffAdminPromises);
            const accountAdminsArray = await getEmployeeTypeData(accountAdminPromises);

            dispatch({
                type: types.GET_COMPANY_INFO,
                payload: {
                    companyInfo: companySnap.val(),
                    providers: providersArray,
                    accountAdmins: accountAdminsArray,
                    staffAdmins: staffAdminsArray
                }
            });
        }
        db.ref(`/providerCompanies/${id}`).once('value', await onGetInfo, e => console.log);
    });
}

export const getServices = () => async dispatch => { // TODO: this is a duplicate action creator, remove and use the one in services-actions
    const onGetServices = (snap) => {
        dispatch({
            type: types.GET_SERVICES,
            payload: snap.val()
        })
    }
    const servicesRef = db.ref(`/services`);
    servicesRef.off();
    servicesRef.on('value', onGetServices, e => console.log); // Using on here so that changes to services on the backend trigger a refresh on the front end with the new data
}

export const selectItem = (type, info) => async dispatch => {
    return new Promise((resolve, reject) => {
        const typeUpperCase = type.toUpperCase()
        const typeString = `SELECT_${typeUpperCase}`
        dispatch({
            type: types[typeString],
            payload: info
        })
        resolve(true);
    })
}

export const resetSelections = () => dispatch => {
    dispatch({
        type: types.RESET_SELECTIONS
    })
}


// FIREBASE FUNCTIONS TO SET THE UPDATE STRUCTURE FOR THE NODES
const setUserValues = async ({
    updates,
    updatedUserData
}) => {
    const userId = updatedUserData.uid;
    for (const itemFieldKey of Object.keys(updatedUserData)) {
        if (updatedUserData[itemFieldKey] !== null && typeof updatedUserData[itemFieldKey] === 'object') {
            Object.keys(updatedUserData[itemFieldKey]).forEach(parameterSubField => {
                updates[`/clients/${userId}/${itemFieldKey}/${parameterSubField}`] = updatedUserData[itemFieldKey][parameterSubField];
            })
        } else {
            updates[`/clients/${userId}/${itemFieldKey}`] = updatedUserData[itemFieldKey];
        }
    }
    return updates;
};

const setItemUpdates = ({
    updates,
    itemType,
    itemDataToBeUploaded,
    itemId
}) => {
    for (const itemFieldKey of Object.keys(itemDataToBeUploaded)) {
        updates[`/${itemType}/${itemId}/${itemFieldKey}`] = itemDataToBeUploaded[itemFieldKey];
    }
    return updates;
}


const getProfilePhotoURL = async ({
    imageData
}) => {
    let profilePhotoURL = null;
    const userId = imageData.uid;
    if (imageData['profilePhotoURL'] instanceof File) {
        let fileURL = await _getImageURL({
            imageData: imageData['profilePhotoURL'],
            dbNodeId: userId,
            imageType: 'profilePhotoURL'
        });
        profilePhotoURL = fileURL;
    } else {
        profilePhotoURL = imageData['profilePhotoURL'];
    }
    return profilePhotoURL;
}

const setCompanyValues = async ({
    updates,
    companyId,
    companyInfo
}) => {
    for (const itemFieldKey of Object.keys(companyInfo)) {
        if (companyInfo[itemFieldKey] instanceof File) {
            let fileURL = await _getImageURL({
                imageData: companyInfo[itemFieldKey],
                dbNodeId: companyId,
                imageType: itemFieldKey
            });
            updates[`/providerCompanies/${companyId}/${itemFieldKey}`] = fileURL;
        } else {
            updates[`/providerCompanies/${companyId}/${itemFieldKey}`] = companyInfo[itemFieldKey]
        }
    }
    return updates;
}

const setProviderPersonalValues = async ({
    itemDataToBeUploaded,
    originalItemData
}) => {
    for (const itemFieldKey of Object.keys(originalItemData)) {
        if (acceptedPersonalValues.includes(itemFieldKey)) {
            itemDataToBeUploaded[itemFieldKey] = originalItemData[itemFieldKey]
        }
    };
    return itemDataToBeUploaded;
};

const setProviderSpecificValues = async ({
    itemDataToBeUploaded,
    originalItemData
}) => {
    Object.keys(originalItemData).forEach(itemFieldKey => {
        if (!acceptedPersonalValues.includes(itemFieldKey) && !(originalItemData[itemFieldKey] instanceof File)) {
            itemDataToBeUploaded[itemFieldKey] = originalItemData[itemFieldKey]
        }
    });
    return itemDataToBeUploaded;
}

const setServiceValues = async ({
    itemDataToBeUploaded,
    originalItemData
}) => {
    Object.keys(originalItemData).forEach(itemFieldKey => {
        if (!(originalItemData[itemFieldKey] instanceof File) && itemFieldKey !== '_id') {
            itemDataToBeUploaded[itemFieldKey] = originalItemData[itemFieldKey]
        }
    });
    return itemDataToBeUploaded;
}

const setCoverPhotoURL = async ({
    itemDataToBeUploaded,
    originalItemData
}) => {
    if (originalItemData['coverPhotoURL'] instanceof File) {
        const dbNodeId = itemDataToBeUploaded.uid || itemDataToBeUploaded._id;
        let coverPhotoURL = await _getImageURL({
            imageData: originalItemData['coverPhotoURL'],
            dbNodeId,
            imageType: 'coverPhotoURL'
        });
        itemDataToBeUploaded['coverPhotoURL'] = coverPhotoURL;
    } else {
        itemDataToBeUploaded['coverPhotoURL'] = originalItemData['coverPhotoURL'];
    }
    return itemDataToBeUploaded;
}


export const createCompany = ({
    formattedUserData,
    formattedProviderData,
    companyInfo,
    user
}) => async dispatch => {
    return new Promise(async (resolve, reject) => {
        const companyRefs = db.ref(`/providerCompanies`);
        const newCompanyRefs = companyRefs.push();
        const userId = user.uid;
        let itemDataToBeUploaded = {};
        let updates = {};

        const originalItemData = {
            ...formattedProviderData,
            providerCompany: newCompanyRefs.key,
            uid: userId
        };

        const updatedUserData = {
            ...formattedUserData,
            providerCompany: newCompanyRefs.key,
            uid: userId
        };

        updates = await setUserValues({
            updatedUserData,
            updates
        });

        const profilePhotoURL = await getProfilePhotoURL({
            imageData: updatedUserData
        });
        updates[`/clients/${userId}/profilePhotoURL`] = profilePhotoURL;
        updates[`/clients/${userId}/basicProfile/profilePhotoURL`] = profilePhotoURL;
        itemDataToBeUploaded['profilePhotoURL'] = profilePhotoURL;

        const companyUpdatedInfo = {
            ...companyInfo,
            contact: {
                firstName: updatedUserData.basicProfile.firstName,
                lastName: updatedUserData.basicProfile.lastName,
                email: user.email
            },
            _id: newCompanyRefs.key,
            accountAdmins: {
                [userId]: {
                    uid: userId
                }
            },
            staffAdmins: {
                [userId]: {
                    uid: userId
                }
            }
        };

        itemDataToBeUploaded = await setProviderPersonalValues({
            itemDataToBeUploaded,
            originalItemData
        });
        itemDataToBeUploaded['permissionsType'] = 'accountAdmins';
        itemDataToBeUploaded['roles'] = originalItemData['roles'];
        itemDataToBeUploaded['uid'] = originalItemData['uid'];

        if (formattedUserData.roles && formattedUserData.roles.provider) {
            itemDataToBeUploaded = await setProviderSpecificValues({
                itemDataToBeUploaded,
                originalItemData
            });
            itemDataToBeUploaded = await setCoverPhotoURL({
                itemDataToBeUploaded,
                originalItemData
            });
            updates[`/providers/${itemDataToBeUploaded.uid}`] = itemDataToBeUploaded;
            companyUpdatedInfo['providers'] = {
                [userId]: {
                    uid: userId
                }
            }
        };
        updates = await setCompanyValues({
            updates,
            companyId: newCompanyRefs.key,
            companyInfo: companyUpdatedInfo
        })

        updates[`/accountAdmins/${userId}`] = itemDataToBeUploaded;
        updates[`/staffAdmins/${userId}`] = itemDataToBeUploaded;


        db.ref().update(updates, error => {
            if (error) {
                // The write failed...
                console.log(error);
                resolve(false);
            } else {
                // Data saved successfully!
                console.log('success updating client');
                resolve(true);
                dispatch({
                    type: types.COMPANY_CREATION_SUCCESS,
                    payload: companyUpdatedInfo
                });
            }
        });
    });
}

export const updateCompanyInfo = ({
    companyId,
    companyInfo
}) => async dispatch => {
    return new Promise(async (resolve, reject) => {
        let updates = {};
        updates = await setCompanyValues({
            updates,
            companyId,
            companyInfo
        });
        db.ref().update(updates, error => {
            if (error) {
                console.log(error);
                const errorMessage = error.errorInfo ? error.errorInfo.message : 'Unknown error';
                db.ref(`providerCompanies/${companyId}/messageQueue/`).push({
                    type: 'error',
                    type: 'Error',
                    message: errorMessage
                });
                resolve(false);
            } else {
                console.log('update company succesful');
                db.ref(`providerCompanies/${companyId}/messageQueue/`).push({
                    type: 'success',
                    title: 'Success',
                    message: 'The update has been successful'
                });
                resolve(true);
            }
        });
    });
}

const getItemUniqueID = async ({ itemDataToBeUploaded, originalItemData, itemType }) => {
    const { uid, _id } = originalItemData;
    let itemId = uid || _id;
    if ( !uid && !_id ){
        const itemNodeRef = db.ref(`${itemType}`);
        const newItemRef = itemNodeRef.push();
        itemId = newItemRef.key;
    }
    const isItemAService = type => type === 'services' ? true : false;
    itemDataToBeUploaded[isItemAService(itemType) ? '_id' : 'uid'] = itemId;
    return itemDataToBeUploaded;
}

const checkForUndefinedValues = (updates) => {
    // Avoid firebase issues with undefined values
    const listOfUndefinedValues = Object.values(updates).filter(value => value === undefined);
    const hasUndefinedValues = listOfUndefinedValues.length > 0 ? true : false;
    return hasUndefinedValues;
};

const updateDBData = async ({ updates, companyId }) => {
    //console.log('updates',JSON.parse(JSON.stringify(updates)));

    const hasUndefinedValues = checkForUndefinedValues(updates);

    const isUpdateSuccessful = !hasUndefinedValues
        ? await db.ref().update(updates, error => console.log(error))
        .then(() => {
            console.log('Update succesful');
            companyId && db.ref(`providerCompanies/${companyId}/messageQueue/`).push({
                type: 'success',
                title: 'Success',
                message: 'Operation has been successful'
            });
            return true;
        }).catch( error => {
            console.log(error);
            const errorMessage = error.errorInfo ? error.errorInfo.message : 'Unknown error';
            companyId && db.ref(`providerCompanies/${companyId}/messageQueue/`).push({
                type: 'error',
                type: 'Error',
                message: errorMessage
            });
            return false;
        })
        : false; // TODO ERROR SCREEN WHEN FALSE
    // console.log('success', isUpdateSuccessful);
    return isUpdateSuccessful;
}

export const addCompanyItem = ({
    itemType,
    companyId,
    itemData
}) => async dispatch => {
    return new Promise(async (resolve, reject) => {
        let itemDataToBeUploaded = {};
        let updates = {};
        let itemId;
        const originalItemData = {
            ...itemData,
        }
        itemDataToBeUploaded = await getItemUniqueID({
            originalItemData,
            itemDataToBeUploaded,
            itemType
        });
        let companyItemNode = 'pendingProviderAccounts';
        switch (itemType) {
            case 'accountAdmins':
            case 'staffAdmins':
            case 'providers':
                let profilePhotoURL = null;
                itemDataToBeUploaded = await setProviderPersonalValues({
                    itemDataToBeUploaded,
                    originalItemData
                });
                profilePhotoURL = await getProfilePhotoURL({
                    imageData: originalItemData
                });
                itemDataToBeUploaded['profilePhotoURL'] = profilePhotoURL;
                itemDataToBeUploaded['permissionsType'] = itemType;
                itemDataToBeUploaded['roles'] = originalItemData.roles;
                itemDataToBeUploaded['providerCompany'] = companyId;

                itemId = itemDataToBeUploaded['uid'];

                const { provider, staffAdmin, accountAdmin } = originalItemData.roles;

                if (provider) {
                    itemDataToBeUploaded = await setProviderSpecificValues({
                        itemDataToBeUploaded,
                        originalItemData
                    });
                    itemDataToBeUploaded = await setCoverPhotoURL({
                        itemDataToBeUploaded,
                        originalItemData
                    });
                    updates = await setItemUpdates({
                        updates,
                        itemType: 'providers',
                        itemDataToBeUploaded,
                        itemId
                    });
                }

                if ( accountAdmin ) {
                    updates = await setItemUpdates({
                        updates,
                        itemType: 'accountAdmins',
                        itemDataToBeUploaded,
                        itemId
                    });
                }

                if ( staffAdmin ) {
                    updates = await setItemUpdates({
                        updates,
                        itemType: 'staffAdmins',
                        itemDataToBeUploaded,
                        itemId
                    });
                };

                updates[`/providerCompanies/${companyId}/${companyItemNode}/${itemId}`] = {
                    uid: itemId,
                    type: itemType,
                };
                break;
            case 'services':
                itemId = itemDataToBeUploaded['_id'];
                itemDataToBeUploaded = await setServiceValues({
                    itemDataToBeUploaded,
                    originalItemData
                });
                itemDataToBeUploaded = await setCoverPhotoURL({
                    itemDataToBeUploaded,
                    originalItemData
                });

                itemDataToBeUploaded['company'] = companyId;
                updates = await setItemUpdates({
                    updates,
                    itemType,
                    itemDataToBeUploaded,
                    itemId
                });
                updates[`/providers/${itemData.provider}/services/${itemDataToBeUploaded._id}`] = {
                    _id: itemDataToBeUploaded._id
                };
                updates[`/providerCompanies/${companyId}/services/${itemDataToBeUploaded._id}`] = {
                    _id: itemDataToBeUploaded._id
                };
                break;
            default:
                break;
        }
        await updateDBData({
            updates,
            companyId
        }).then( success => {
            if (success) {
                if (itemType === 'providers') {
                    const employeeCreationResultRef = db.ref(`providerCompanies/${companyId}/employeeCreationResult`);
                    // SETTING TO NULL IN CASE IT WASN'T NULLIFIED AT LAST RUN
                        // SMALL RISK OF employeeCreation SETTING A LEGITIMATE NEW VALUE AND IT BEING NULLIFIED HERE - WILL RESULT IN AN INFINITE SPINNER
                    employeeCreationResultRef.set(null, err => {
                        if (err) console.log('Firebase error', err)
                    });
                    employeeCreationResultRef.on('value', employeeCreationResultSnap => {
                            const employeeCreationResult = employeeCreationResultSnap.val();
                            if (employeeCreationResult === 'success') {
                                employeeCreationResultRef.off();
                                console.log('Employee creation succesful');
                                dispatch({
                                    type: types.FORM_SUBMISSION_SUCCESSFUL,
                                    payload: true
                                });
                                employeeCreationResultRef.set(null, err => {
                                    if (err) console.log('Firebase error', err)
                                });
                                resolve(true);
                            } else if (employeeCreationResult === 'failed') {
                                employeeCreationResultRef.off();
                                console.log('Employee creation failed');
                                employeeCreationResultRef.set(null, err => {
                                    if (err) console.log('Firebase error', err)
                                });
                                resolve(false);
                            }
                    }, (err) => {
                        console.log('Firebase error', err);
                        resolve(false);
                    });
                } else if (itemType === 'services') {
                    const serviceCreationResultRef = db.ref(`services/${itemDataToBeUploaded._id}/SBMId`);
                    serviceCreationResultRef.on('value', serviceCreationResultSnap => {
                        const serviceCreationResult = serviceCreationResultSnap.val();
                        if (serviceCreationResult) {
                            serviceCreationResultRef.off();
                            console.log('Service creation successful')
                            dispatch({
                                type: types.FORM_SUBMISSION_SUCCESSFUL,
                                payload: true
                            });
                            resolve(true);
                        };
                    }, (err) => {
                        console.log(err);
                        resolve(false);
                    });
                } else {
                    dispatch({
                        type: types.FORM_SUBMISSION_SUCCESSFUL,
                        payload: true
                    });
                    resolve(true);
                };
            } else {
                resolve(false);
            };
        });
    });
}

const updateCompanyEmployees = ({roleChanges,updates,itemId,companyId, currentRoles}) => {
    Object.keys(roleChanges).forEach( roleChange => {
        if( roleChanges[roleChange] ){
            updates[`/providerCompanies/${companyId}/${roleChange}s/${itemId}`] = currentRoles && currentRoles[roleChange]
            ? {
                uid: itemId,
            }
            : null
        }
    });
    return updates;
}

const updateClientPhone = ({ updates, phoneNumber, itemId }) => {
    updates[`/clients/${itemId}/basicProfile/phone`] =  phoneNumber;
    return updates;
};

export const updateCompanyItem = ({
    companyId,
    itemData,
    itemType,
    roleChanges
}) => async dispatch => {
    return new Promise(async (resolve, reject) => {
        let itemDataToBeUploaded = {};
        let updates = {};
        let itemId;

        const phoneNumber = itemData['phone'];
        const originalItemData = {
            ...itemData,
            phone: null
        }
        itemDataToBeUploaded = await getItemUniqueID({
            originalItemData,
            itemDataToBeUploaded,
            itemType
        });

        switch (itemType) {
            case 'accountAdmins':
            case 'staffAdmins':
            case 'providers':
                let profilePhotoURL = null;
                itemDataToBeUploaded = await setProviderPersonalValues({
                    itemDataToBeUploaded,
                    originalItemData
                });
                profilePhotoURL = await getProfilePhotoURL({
                    imageData: originalItemData
                });
                itemDataToBeUploaded['profilePhotoURL'] = profilePhotoURL;
                itemDataToBeUploaded['permissionsType'] = itemType;

                itemId = itemDataToBeUploaded['uid'];

                updates = updateClientPhone({
                    updates,
                    phoneNumber,
                    itemId
                });

                const { provider, staffAdmin, accountAdmin } = originalItemData.roles;

                if (provider) {
                    itemDataToBeUploaded = await setProviderSpecificValues({
                        itemDataToBeUploaded,
                        originalItemData
                    });
                    itemDataToBeUploaded = await setCoverPhotoURL({
                        itemDataToBeUploaded,
                        originalItemData
                    });
                    updates = await setItemUpdates({
                        updates,
                        itemType: 'providers',
                        itemDataToBeUploaded,
                        itemId
                    });
                };

                if ( accountAdmin ) {
                    updates = await setItemUpdates({
                        updates,
                        itemType: 'accountAdmins',
                        itemDataToBeUploaded,
                        itemId
                    });
                };

                if ( staffAdmin ) {
                    updates = await setItemUpdates({
                        updates,
                        itemType: 'staffAdmins',
                        itemDataToBeUploaded,
                        itemId
                    });
                };

                updates = updateCompanyEmployees({
                    roleChanges,
                    currentRoles: originalItemData && originalItemData.roles,
                    updates,
                    itemId,
                    companyId
                });

                break;
            case 'services':
                itemId = itemDataToBeUploaded['_id']
                itemDataToBeUploaded = await setServiceValues({
                    itemDataToBeUploaded,
                    originalItemData
                });
                itemDataToBeUploaded = await setCoverPhotoURL({
                    itemDataToBeUploaded,
                    originalItemData
                });
                updates = setItemUpdates({
                    updates,
                    itemType,
                    itemDataToBeUploaded,
                    itemId
                });
                break;
            default:
                break;
        }

        await updateDBData({
            updates,
            companyId
        }).then( success => {
            return success
                ? resolve (true)
                : resolve (false)
        });

    });
}

export const removeCompanyItem = ({
    companyId,
    itemId,
    itemType,
    provider
}) => async dispatch => {

    let itemsToRemove = {};
    itemsToRemove[`/providerCompanies/${companyId}/${itemType}/${itemId}`] = null
    itemsToRemove[`/${itemType}/${itemId}`] = null

    if (itemType === 'services') {
        itemsToRemove[`/providers/${provider}/services/${itemId}`] = null
    }

    db.ref().update(itemsToRemove, error => {
        if (error) {
            console.log(error);
            const errorMessage = error.errorInfo ? error.errorInfo.message : 'Unknown error';
            db.ref(`providerCompanies/${companyId}/messageQueue/`).push({
                type: 'error',
                type: 'Error',
                message: errorMessage
            });
        } else {
            console.log('remove succesful');
            db.ref(`providerCompanies/${companyId}/messageQueue/`).push({
                type: 'success',
                title: 'Success',
                message: 'The item removal has been successful'
            });
        }
    });
}

export const findClientAccount = ({
    email
}) => async dispatch => {
    return new Promise((resolve, reject) => {
        const onGetClientAccount = (snap) => {
            const clientToAdd = snap.val();
            console.log('fca fired')
            console.log(clientToAdd)
            if (clientToAdd) {
                resolve(0)
            } else {
                resolve(1)
            }
        }

        db.ref(`/clients`).orderByChild("email").equalTo(email).once('value', onGetClientAccount, console.log);
    })
};

export const changeWizardStep = ({
    newPage
}) => async dispatch => {
    dispatch({
        type: types.CHANGE_WIZARD_STEP,
        payload: newPage
    });
}

//Copy of the function generatePass from the cloud functions with a small modification so that it can be used to create the activation code
export const generateCode = (length) => {
    var chars = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNPQRSTUVWXYZ";
    var pass = "";
    for (let i = 0; i < length; i++) {
        pass += chars[Math.floor(Math.random() * chars.length)];
    }
    return pass;
}

export const createUserAccount = ({
    companyId,
    email,
    firstName,
    lastName,
    phoneNumber
}) => async dispatch => {
    return new Promise((resolve, reject) => {
        const activationCode = generateCode(8);

        let pendingAccountUpdates = {};
        let tempNewClientDataKey = db.ref().push().key;

        let pendingAccountsRef = db.ref(`/providerCompanies/${companyId}/pendingAccounts`);
        let newAccountRef = pendingAccountsRef.push();

        let accountInfo = {
            email,
            activationCode,
            uid: newAccountRef.key,
            firstName,
            lastName,
            phone: phoneNumber,
            tempNewClientDataKey
        }
        pendingAccountUpdates[`/providerCompanies/${companyId}/pendingAccounts/${newAccountRef.key}`] = accountInfo;

        db.ref().update(pendingAccountUpdates, error => {
            if (error) {
                console.log(error);
                const errorMessage = error.errorInfo ? error.errorInfo.message : 'Unknown error';
                db.ref(`providerCompanies/${companyId}/messageQueue/`).push({
                    type: 'error',
                    type: 'Error',
                    message: errorMessage
                });
                reject();
            } else {
                console.log('update company pending accounts succesful');
                // MOVED NOTIFICATION TO booking-actions LINE 214 FOR BETTER TIMING
                dispatch({
                    type: types.SET_ACTIVATION_CODE,
                    payload: activationCode
                })
                resolve(tempNewClientDataKey);
            }
        })
    })
}

export const handleDialogStatusChange = ({
    open,
    type,
    step
}) => async dispatch => {
    dispatch({
        type: types.CHANGE_DIALOG_STATUS,
        payload: {
            open,
            type,
            step
        }
    });
}

export const dispatchAdminFormData = ({
    formattedUserData,
    formattedProviderData
}) => async dispatch => {
    dispatch({
        type: types.SETUP_ADMIN_DATA,
        payload: {
            formattedProviderData,
            formattedUserData,
            waitingOnCompanySetupFormData: true,
        }
    })
}


// WEBPACK FOOTER //
// ./src/js/actions/company-actions.js